var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22.857,
    viewBox: "0 0 20 22.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71b6f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.857,11.428H6.786v-4.6a3.214,3.214,0,1,1,6.429-.04V7.5A1.069,1.069,0,0,0,14.286,8.57h1.429A1.069,1.069,0,0,0,16.786,7.5V6.785a6.786,6.786,0,1,0-13.571.067v4.576H2.143A2.143,2.143,0,0,0,0,13.57v7.143a2.143,2.143,0,0,0,2.143,2.143H17.857A2.143,2.143,0,0,0,20,20.713V13.57A2.143,2.143,0,0,0,17.857,11.428Z",
    transform: "translate(0 0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockSolid);
export default __webpack_public_path__ + "static/media/unlock-solid.002c5d2bfded14c0da904d20e433b6c5.svg";
export { ForwardRef as ReactComponent };